import {
  LitElement,
  html,
  css,
  unsafeHTML,
  ref,
  createRef,
  utils,
  paths,
  t,
  styles,
  classMap,
  range,
  map,
} from '@hh/global.js'

class HHMenuFeaturedContent extends LitElement {
  static get properties() {
    return {
      _current: {
        state: true,
      },
      _total: {
        state: true,
      },
    }
  }

  $container = createRef()

  constructor() {
    super()

    this._total = 0
    this._current = 0
    this.items = []
    this.containerWidth = 0
    this._totalWidth = 0

    this.updateUI = this.updateUI.bind(this)
    this.move = this.move.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.items = Array.from(this.querySelectorAll('[slot="item"]'))
    this._total = this.items.length

    this.$container?.value?.addEventListener('scroll', this.updateUI)
    if (this.breakpoint) {
      this.observer.observe(document.body)
    }
    this._containerWidth = this.closest(
      'hh-menu-featured-content'
    ).getBoundingClientRect().width
    this._totalWidth = this._total * this.items[0].clientWidth
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.$container?.value?.removeEventListener('scroll', this.updateUI)
    this.observer.disconnect()
  }

  firstUpdated() {
    this.$container?.value?.addEventListener('scroll', this.updateUI)
    if (this.breakpoint) {
      this.observer.observe(document.body)
    }
  }

  updateUI() {
    if (!this._total) {
      return
    }

    this._current = Math.round(
      this.$container?.value?.scrollLeft / this.items[0].clientWidth
    )
  }

  move(event) {
    event.preventDefault()

    let slideWidth = this.items[0].clientWidth

    const slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.$container?.value?.scrollLeft + slideWidth
        : this.$container?.value?.scrollLeft - slideWidth
    this.$container?.value?.scrollTo({
      left: slideScrollPosition,
    })
  }

  render() {
    return html`
      <div class="container">
        <div class="carousel" ${ref(this.$container)}>
          <slot name="item"></slot>
        </div>
        <div class="${classMap({
          pagination: true,
          hide: this._total <= 1,
        })}">
            ${map(range(this._total), (idx) => {
              return html`
                <button
                  class="dot"
                  aria-label="${t('accessibility.go_to_slide', 'Slide')} ${idx +
                  1}"
                  aria-current="${this._current === idx ? 'true' : 'false'}"
                  ?disabled="${this._current === idx}"
                >
                  <span class="dot__inner"></span>
                </button>
              `
            })}
          </div>
        </div>
      </div>
    `
  }

  static get styles() {
    return css`
      .container {
        position: relative;
      }

      .carousel {
        height: 14.3750rem;
        display: flex;
        flex-wrap: nowrap;
        position: relative;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;
        z-index: 20;
      }

      .carousel::-webkit-scrollbar {
        display: none;
      }

      .pagination {
        position: absolute;
        bottom: 0.7500rem;
        right: 1.2500rem;
        display: flex;
        align-items: center;
        gap: 0.3750rem;
        z-index: 30;
      }

      .dot {
        all: unset;
        cursor: pointer;
      }

      .dot:focus-visible {
        outline: 0.0625rem solid var(--hh-color-focus);
      }

      .dot__inner {
        display: block;
        height: 0.6250rem;
        width: 0.6250rem;
        border-radius: 100%;
        border: 0.0625rem solid var(--hh-color-neutral);
        transition: all var(--hh-duration-medium) ease-in;
      }

      .dot[aria-current='true'] .dot__inner {
        background: var(--hh-color-day);
      }
    `
  }
}

customElements.define('hh-menu-featured-content', HHMenuFeaturedContent)
